import {
  IN_APP_NOTIFICATIONS_LIST,
  NOTIFICATION_CENTER_ADD_PERIODICAL_NOTIFICATION,
  NOTIFICATION_CENTER_DELETE_PERIODICAL_NOTIFICATION,
  NOTIFICATION_CENTER_EDIT_ABSOLUTE_NOTIFICATION,
  NOTIFICATION_CENTER_EDIT_PERIODICAL_NOTIFICATION,
  NOTIFICATIONS_HISTORY_SUBSCRIPTION_SENT_GET,
  USERPREF_GET_NOTIFICATIONS_BY_SUBSCRIPTION_NUMBERS,
} from "@shared/services/tour/urls/dashboard-urls.ts";
import notificationsHistorySubscriptionSentGet from "@shared/services/tour/mockedApis/notificationCenter/notificationsHistorySubscriptionSentGet.ts";
import getNotificationsBySubscriptionNumbers from "@shared/services/tour/mockedApis/notificationCenter/getNotificationsBySubscriptionNumbers.ts";
import addNotification from "@shared/services/tour/mockedApis/notificationCenter/addNotification.ts";
import editNotification from "@shared/services/tour/mockedApis/notificationCenter/editNotification.ts";
import { TourUrlMapping } from "@shared/types/localTypes/tour.ts";
import genericEmptyResponse from "@shared/services/tour/mockedApis/generic/genericEmptyResponse.ts";
import getInAppNotificationsList from "@shared/services/tour/mockedApis/notificationCenter/getInAppNotificationsList.ts";

export default {
  [NOTIFICATIONS_HISTORY_SUBSCRIPTION_SENT_GET]: () =>
    notificationsHistorySubscriptionSentGet(),
  [USERPREF_GET_NOTIFICATIONS_BY_SUBSCRIPTION_NUMBERS]: () =>
    getNotificationsBySubscriptionNumbers(),
  [NOTIFICATION_CENTER_ADD_PERIODICAL_NOTIFICATION]: () => addNotification(),
  [NOTIFICATION_CENTER_DELETE_PERIODICAL_NOTIFICATION]: () =>
    genericEmptyResponse(),
  [NOTIFICATION_CENTER_EDIT_PERIODICAL_NOTIFICATION]: (data, config) =>
    editNotification(data, config),
  [NOTIFICATION_CENTER_EDIT_ABSOLUTE_NOTIFICATION]: (data, config) =>
    editNotification(data, config),
  [IN_APP_NOTIFICATIONS_LIST]: () => getInAppNotificationsList(),
} satisfies TourUrlMapping;
